import React, { useRef, useEffect } from 'react';
import ScrollFade from '../shared/ScrollFade';

export default function CantiereTabNav({ tabs, activeTab, onTabChange }) {
  const activeRef = useRef(null);

  // Voce 17 — porta la tab attiva nel viewport quando cambia (es. la 9ª tab
  // fuori campo dopo lo scroll o su schermi stretti). inline:'nearest' scrolla
  // solo in orizzontale dentro lo scroller di ScrollFade, senza muovere la pagina.
  useEffect(() => {
    if (activeRef.current) {
      activeRef.current.scrollIntoView({ inline: 'nearest', block: 'nearest' });
    }
  }, [activeTab]);

  return (
    // Voce 17 — la barra 9-tab scrolla con un fade sul bordo che segnala le tab
    // nascoste (prima: scroll muto, nessun indizio). Stesso pattern della voce 16.
    <ScrollFade style={{ borderBottom: '1px solid var(--ds-border)' }} hideScrollbar>
      <div style={{ display: 'flex', padding: '0 24px', gap: 4 }}>
        {tabs.map(tab => {
          const isActive = tab.id === activeTab;
          return (
            <button
              key={tab.id}
              ref={isActive ? activeRef : null}
              onClick={() => onTabChange(tab.id)}
              onMouseEnter={(e) => { if (!isActive) e.currentTarget.style.color = 'var(--ds-text)'; }}
              onMouseLeave={(e) => { if (!isActive) e.currentTarget.style.color = 'var(--ds-muted)'; }}
              style={{
                padding: '10px 16px',
                border: 'none',
                borderBottom: isActive ? '2px solid var(--brand)' : '2px solid transparent',
                background: 'none',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                fontSize: 13,
                fontWeight: isActive ? 500 : 400,
                color: isActive ? 'var(--brand)' : 'var(--ds-muted)',
                transition: 'all 0.15s ease',
                minHeight: 44,
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </ScrollFade>
  );
}
